import React, { useState } from 'react';
import { 
  DndContext, 
  rectIntersection, 
  PointerSensor, 
  useSensor, 
  useSensors,
  DragOverlay
} from '@dnd-kit/core';
import { 
  SortableContext, 
  verticalListSortingStrategy, 
  useSortable,
  arrayMove 
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Play, GripVertical, Info, Trophy, Plus, X, User } from 'lucide-react';
import Swal from 'sweetalert2';

// --- 0. COMPOSANT : MODALE AJOUT MANUEL ---
function ManualMatchModal({ isOpen, onClose, onAdd, allAthletes, categories, ringId }) {
  const [a1, setA1] = useState("");
  const [a2, setA2] = useState("");
  const [catId, setCatId] = useState("");
  const [label, setLabel] = useState("MANUEL");

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!a1 || !a2 || !catId) {
      Swal.fire('Champs requis', "Veuillez sélectionner les deux athlètes et une catégorie", 'warning');
      return;
    }
    if (a1 === a2) {
      Swal.fire('Erreur', "Un athlète ne peut pas combattre contre lui-même", 'error');
      return;
    }

    const cat = categories.find(c => String(c.id) === String(catId));
    onAdd({
      athlete1_id: a1,
      athlete2_id: a2,
      category_id: catId,
      category_name: cat?.name || "Manuel",
      poule_label: label || "MANUEL"
    });
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white', borderRadius: '16px', width: '100%', maxWidth: '500px',
        boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)', overflow: 'hidden',
        display: 'flex', flexDirection: 'column', maxHeight: '90vh'
      }}>
        {/* Header */}
        <div style={{
          padding: '20px', borderBottom: '1px solid #edf2f7', display: 'flex',
          justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f8fafc'
        }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: '#2d3748' }}>
            Nouveau combat - Ring {ringId}
          </h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#a0aec0' }}>
            <X size={24} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ padding: '20px', overflowY: 'auto' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            
            {/* Athlètes */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <div style={{ backgroundColor: '#fff5f5', padding: '15px', borderRadius: '12px', border: '1px solid #fed7d7' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: 'bold', color: '#c53030', marginBottom: '8px' }}>
                  <User size={14} /> COIN ROUGE
                </label>
                <select 
                  value={a1} 
                  onChange={(e) => setA1(e.target.value)}
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e0', fontSize: '14px' }}
                >
                  <option value="">Sélectionner un tireur</option>
                  {allAthletes.map(a => {
                    const fullName = a.name || `${(a.nom || "").toUpperCase()} ${a.prenom || ""}`.trim();
                    return (
                        <option key={a.id} value={a.id}>{fullName} ({a.club || "Sans club"})</option>
                    );
                  })}
                </select>
              </div>

              <div style={{ backgroundColor: '#ebf8ff', padding: '15px', borderRadius: '12px', border: '1px solid #bee3f8' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: 'bold', color: '#2b6cb0', marginBottom: '8px' }}>
                  <User size={14} /> COIN BLEU
                </label>
                <select 
                  value={a2} 
                  onChange={(e) => setA2(e.target.value)}
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e0', fontSize: '14px' }}
                >
                  <option value="">Sélectionner un tireur</option>
                  {allAthletes.map(a => {
                    const fullName = a.name || `${(a.nom || "").toUpperCase()} ${a.prenom || ""}`.trim();
                    return (
                        <option key={a.id} value={a.id}>{fullName} ({a.club || "Sans club"})</option>
                    );
                  })}
                </select>
              </div>
            </div>

            {/* Catégorie */}
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 'bold', color: '#4a5568', marginBottom: '8px' }}>CATÉGORIE</label>
              <select 
                value={catId} 
                onChange={(e) => setCatId(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e0', fontSize: '14px' }}
              >
                <option value="">-- Choisir une catégorie --</option>
                {categories.map(c => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>

            {/* Label */}
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 'bold', color: '#4a5568', marginBottom: '8px' }}>TYPE DE COMBAT</label>
              <input 
                type="text" 
                value={label} 
                onChange={(e) => setLabel(e.target.value)}
                placeholder="Ex: MANUEL, FINALE, HORS CONCOURS..."
                style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e0', fontSize: '14px' }}
              />
            </div>
          </div>

          <div style={{ marginTop: '30px', display: 'flex', gap: '12px' }}>
            <button type="button" onClick={onClose} style={{ flex: 1, padding: '12px', borderRadius: '10px', border: '1px solid #e2e8f0', backgroundColor: 'white', color: '#4a5568', fontWeight: 'bold', cursor: 'pointer' }}>
              Annuler
            </button>
            <button type="submit" style={{ flex: 2, padding: '12px', borderRadius: '10px', border: 'none', backgroundColor: '#3182ce', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}>
              Ajouter au Ring {ringId}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// --- 1. COMPOSANT INTERNE : SORTABLE MATCH ---
function SortableMatch({ match, index, allAthletes, order, isOverlay = false }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: match.id });

  // LOGIQUE DE COULEUR
  const isElim = match.type === 'elimination' || match.format === 'elimination' || match.format === 'elimination_directe';
  const badgeColor = isElim ? "#3182ce" : "#38a169"; 
  const badgeBg = isElim ? "#ebf8ff" : "#f0fff4";

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging && !isOverlay ? 0.3 : 1,
    backgroundColor: "white",
    padding: "15px",
    borderRadius: "10px",
    boxShadow: isOverlay || isDragging ? "0 10px 20px rgba(0,0,0,0.15)" : "0 2px 4px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginBottom: "12px",
    borderLeft: `4px solid ${badgeColor}`,
    zIndex: isOverlay ? 1000 : 1,
    position: "relative",
    border: "1px solid #e2e8f0",
    touchAction: 'none',
    cursor: isOverlay ? 'grabbing' : 'default'
  };

  // --- FONCTION DYNAMIQUE POUR AFFICHER LES VAINQUEURS ---
  const getAthleteDisplay = (id, placeholder, currentMatch, sideNum) => {
    let displayName = placeholder || "À déterminer";

    // RÉSOLUTION DYNAMIQUE VIA COLONNES DÉDIÉES
    if (!id && currentMatch) {
        const sourceId = (sideNum === 2) ? currentMatch.source_match_id2 : currentMatch.source_match_id;
        if (sourceId) {
            const sMatch = (order || []).find(m => String(m.id) === String(sourceId));
            if (sMatch) {
                displayName = `Vainqueur V${sMatch.match_ref}`;
            } else {
                displayName = "En attente...";
            }
        }
    }

    // 1. Recherche de l'athlète réel
    const athleteIdStr = id ? String(id) : null;
    const athlete = athleteIdStr ? (allAthletes || []).find(a => String(a.id) === athleteIdStr) : null;
    
    if (athlete) {
        const nom = athlete.nom || athlete.name || "";
        const prenom = athlete.prenom || athlete.firstname || "";
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontWeight: "700", fontSize: "14px" }}>
                    {`${nom.toUpperCase()} ${prenom}`.trim()}
                </span>
                <span style={{ fontSize: "11px", opacity: 0.8 }}>
                    {athlete.club || "Pas de club"}
                </span>
            </div>
        );
    }

    // 2. Affichage du placeholder (Vainqueur VX ou Texte statique)
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ color: '#718096', fontStyle: 'italic', fontSize: '12px' }}>
                {displayName}
            </span>
        </div>
    );
  };

  return (
    <div ref={setNodeRef} style={style}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div {...attributes} {...listeners} style={{ cursor: "grab", color: "#cbd5e0", padding: '4px' }}>
                <GripVertical size={18} />
            </div>
            <span style={{ fontSize: "12px", fontWeight: "900", color: "#2d3748" }}>
                {match.poule_label === "FINALE" ? "FINALE" : `ASSAUT N°${match.match_ref}`}
            </span>
        </div>
        
        {/* BADGE CORRIGÉ */}
        <span style={{ 
            fontSize: "10px", fontWeight: "800", color: badgeColor, 
            backgroundColor: badgeBg, padding: "3px 8px", borderRadius: "5px",
            textTransform: "uppercase"
        }}>
            {match.poule_label} - {match.category_name}
        </span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
        {/* ATHLETE GAUCHE - ROUGE */}
        <div style={{ flex: 1, textAlign: 'center', color: '#c53030' }}>
            {getAthleteDisplay(match.athlete1_id, match.placeholder1, match, 1)}
        </div>

        <div style={{ fontWeight: "900", color: "#cbd5e0", fontSize: "11px", fontStyle: 'italic' }}>VS</div>

        {/* ATHLETE DROITE - BLEU */}
        <div style={{ flex: 1, textAlign: 'center', color: '#2b6cb0' }}>
            {getAthleteDisplay(match.athlete2_id, match.placeholder2, match, 2)}
        </div>
      </div>
    </div>
  );
}

// --- 2. COMPOSANT PRINCIPAL : MATCHBOARD ---
export default function MatchBoard({ order, currentRings, onUpdateOrder, onGenerate, allAthletes, categories = [], isMobile = false }) {
  const [activeMatch, setActiveMatch] = useState(null);
  const [isManualModalOpen, setIsManualModalOpen] = useState(false);
  const [selectedRingForManual, setSelectedRingForManual] = useState(null);
  const [mobileActiveRing, setMobileActiveRing] = useState(1);
  
  const sensors = useSensors(useSensor(PointerSensor, { 
    activationConstraint: { distance: 8 } 
  }));

  const safeOrder = Array.isArray(order) ? order : [];

  const handleDragStart = (event) => {
    const match = safeOrder.find(m => m.id === event.active.id);
    setActiveMatch(match);
  };

  const handleDragOver = (event) => {
    const { active, over } = event;
    if (!over) return;

    const activeId = active.id;
    const overId = over.id;

    const activeMatchItem = safeOrder.find(m => m.id === activeId);
    if (!activeMatchItem) return;

    const activeRing = activeMatchItem.ring_id;
    const overRing = safeOrder.find(m => m.id === overId)?.ring_id || (typeof overId === 'number' ? overId : null);

    if (!overRing || activeRing === overRing) return;

    const newOrder = [...safeOrder];
    const activeIndex = newOrder.findIndex(m => m.id === activeId);
    
    if (activeIndex !== -1) {
      newOrder[activeIndex].ring_id = overRing;
      onUpdateOrder(newOrder); 
    }
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    setActiveMatch(null);
    if (!over) return;

    if (active.id !== over.id) {
      const oldIndex = safeOrder.findIndex((m) => m.id === active.id);
      const newIndex = safeOrder.findIndex((m) => m.id === over.id);
      
      const updatedOrder = arrayMove(safeOrder, oldIndex, newIndex);
      
      // RÉORDONNANCEMENT PAR RING (match_ref commence à 1 pour chaque ring)
      const ringCounters = {};
      
      // On s'assure de trier par ring d'abord pour une renumérotation cohérente
      const reordered = updatedOrder.map((m) => {
          const rId = m.ring_id;
          ringCounters[rId] = (ringCounters[rId] || 0) + 1;
          return {
              ...m,
              match_ref: ringCounters[rId].toString()
          };
      });

      onUpdateOrder(reordered);
    }
  };

  const handleOpenManualModal = (ringId) => {
    setSelectedRingForManual(ringId);
    setIsManualModalOpen(true);
  };

  const handleAddManualMatch = (formValues) => {
    const ringMatches = safeOrder.filter(m => String(m.ring_id) === String(selectedRingForManual));
    const nextRef = (ringMatches.length + 1).toString();

    const newMatch = {
        id: crypto.randomUUID(),
        competition_id: safeOrder[0]?.competition_id, 
        ...formValues,
        ring_id: parseInt(selectedRingForManual),
        match_ref: nextRef,
        type: 'poule', 
        winner_id: null
    };

    const updatedOrder = [...safeOrder, newMatch];
    onUpdateOrder(updatedOrder);
    Swal.fire({ icon: 'success', title: 'Combat ajouté !', timer: 1500, showConfirmButton: false });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "25px" }}>
      
      <div style={styles.headerBar}>
        <div style={styles.infoGroup}>
          <Trophy size={20} color="#2c5282" />
          <span style={{ fontWeight: "600", fontSize: "14px", color: "#2c5282" }}>
            Ordre de passage officiel sur {currentRings} Rings
          </span>
        </div>
        
        <button onClick={onGenerate} style={styles.refreshBtn}>
          <Play size={14} fill="#3182ce" /> 
          {safeOrder.length > 0 ? "Régénérer l'ordre" : "Générer les combats"}
        </button>
      </div>

      {safeOrder.length > 0 ? (
        <DndContext
            sensors={sensors}
            collisionDetection={rectIntersection}
            onDragStart={handleDragStart}
            onDragOver={handleDragOver}
            onDragEnd={handleDragEnd}
        >
          {isMobile && (
            <div style={{ display: 'flex', gap: '5px', marginBottom: '12px', backgroundColor: '#edf2f7', padding: '5px', borderRadius: '8px', overflowX: 'auto' }}>
              {Array.from({ length: currentRings }, (_, i) => i + 1).map(ringId => (
                <button
                  key={ringId}
                  onClick={() => setMobileActiveRing(ringId)}
                  style={{
                    flex: '1 0 auto', padding: '8px 12px', borderRadius: '6px', border: 'none', cursor: 'pointer', whiteSpace: 'nowrap',
                    backgroundColor: mobileActiveRing === ringId ? 'white' : 'transparent',
                    fontWeight: mobileActiveRing === ringId ? 'bold' : 'normal',
                    color: mobileActiveRing === ringId ? '#2c5282' : '#718096',
                    boxShadow: mobileActiveRing === ringId ? '0 2px 4px rgba(0,0,0,0.08)' : 'none',
                    fontSize: '13px'
                  }}
                >
                  Ring {ringId}
                </button>
              ))}
            </div>
          )}
          <div style={isMobile ? {} : { display: "grid", gridTemplateColumns: `repeat(${currentRings}, 1fr)`, gap: "20px" }}>
            {Array.from({ length: currentRings }, (_, i) => i + 1).map(ringId => {
              if (isMobile && ringId !== mobileActiveRing) return null;
              const ringMatches = safeOrder.filter(m => String(m.ring_id) === String(ringId));
              const ringStringId = String(ringId);

              return (
                <div key={ringStringId} id={ringStringId} style={{ ...styles.ringColumn, minHeight: isMobile ? '200px' : '600px' }}>
                  <div style={styles.ringHeader}>RING {ringId}</div>
                  <div style={styles.matchCount}>{ringMatches.length} COMBATS PRÉVUS</div>

                  <SortableContext 
                    items={ringMatches.map(m => String(m.id))} 
                    strategy={verticalListSortingStrategy}
                  >
                    <div style={{ minHeight: "200px" }}>
                      {ringMatches.map((match, index) => (
                        <SortableMatch 
                          key={String(match.id)} 
                          match={match} 
                          index={index} 
                          allAthletes={allAthletes}
                          order={safeOrder} 
                        />
                      ))}
                    </div>
                  </SortableContext>

                  <button 
                    onClick={() => handleOpenManualModal(ringId)}
                    style={{
                        width: '100%', marginTop: '10px', padding: '12px',
                        backgroundColor: '#f0f7ff', color: '#3182ce', border: '1px dashed #3182ce',
                        borderRadius: '12px', cursor: 'pointer', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', gap: '8px',
                        fontSize: '13px', fontWeight: 'bold', transition: '0.2s'
                    }}
                  >
                    <Plus size={16} /> Ajouter un combat manuel
                  </button>
                </div>
              );
            })}
          </div>

          <ManualMatchModal 
            isOpen={isManualModalOpen}
            onClose={() => setIsManualModalOpen(false)}
            onAdd={handleAddManualMatch}
            allAthletes={allAthletes}
            categories={categories}
            ringId={selectedRingForManual}
          />

          <DragOverlay>
            {activeMatch ? <SortableMatch match={activeMatch} index={0} allAthletes={allAthletes} order={safeOrder} isOverlay /> : null}          
          </DragOverlay>
        </DndContext>
      ) : (
        <div style={styles.emptyState}>
          <Info size={40} color="#cbd5e0" />
          <p>Aucun match généré. Cliquez sur "Générer les combats" ci-dessus.</p>
        </div>
      )}
    </div>
  );
}

const styles = {
  headerBar: { display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "white", padding: "15px 25px", borderRadius: "12px", boxShadow: "0 2px 4px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0"},
  infoGroup: { display: "flex", alignItems: "center", gap: "12px" },
  refreshBtn: { display: "flex", alignItems: "center", gap: "8px", backgroundColor: "#ebf8ff", color: "#3182ce", border: "1px solid #bee3f8", padding: "8px 16px", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "bold"},
  ringColumn: { backgroundColor: "#f8fafc", borderRadius: "16px", padding: "15px", minHeight: "600px", border: "2px solid #edf2f7" },
  ringHeader: { textAlign: "center", fontWeight: "900", color: "#2c5282", fontSize: "15px", marginBottom: "4px" },
  matchCount: { textAlign: "center", fontSize: "11px", color: "#718096", marginBottom: "15px", fontWeight: "700", opacity: 0.7 },
  emptyState: { textAlign: "center", padding: "100px", backgroundColor: "white", borderRadius: "12px", color: "#a0aec0", display: "flex", flexDirection: "column", alignItems: "center", gap: "15px" }
};
